import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-red.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex items-center justify-between flex-row w-full" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "font-semibold text-sm" }
const _hoisted_5 = { class: "font-semibold text-sm px-1" }
const _hoisted_6 = {
  key: 0,
  class: "absolute top-full left-0 bg-white rounded-b-lg shadow-lg z-50 w-350px border border-gray-lp-200"
}
const _hoisted_7 = { class: "p-4 space-y-4" }
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_10 = { class: "border-b border-gray-lp-400 pb-4" }
const _hoisted_11 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_12 = { class: "w-full pl-2.5 py-2 relative max-h-250px overflow-y-auto" }
const _hoisted_13 = { class: "border-b border-gray-lp-400 pb-4" }
const _hoisted_14 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_15 = { class: "border-b border-gray-lp-400 pb-4" }
const _hoisted_16 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_17 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_18 = { class: "flex items-center justify-between p-4 border-t border-gray-lp-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: ["flex items-center px-4 py-2 bg-white border transition-colors duration-200", [
        _ctx.isOpen ? ' w-350px rounded-t-md' : ' w-100px rounded-md',
        _ctx.filterCount > 0
          ? 'bg-red-lp-1300 border-red-lp-300 text-red-lp-100'
          : 'bg-white border-gray-lp-400'
      ]],
      "data-testid": "urgent-delivery-monitor-relabel-filter-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("urgentRelabel.filter.title")), 1),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.filterCount > 0 ? `(${_ctx.filterCount})` : ""), 1)
        ]),
        (_ctx.filterCount === 0)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _imports_0,
              class: 
            `${
              _ctx.isOpen ? 'rotate-180' : 'rotate-0'
            } transition-transform duration-200 w-5 h-5`
          
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: _imports_1,
              class: 
            `${
              _ctx.isOpen ? 'rotate-180' : 'rotate-0'
            } transition-transform duration-200 w-5 h-5`
          
            }, null, 2))
      ])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("urgentRelabel.filter.processedBy")), 1),
              _createVNode(_component_CustomDropdown, {
                "data-testid": "urgent-delivery-monitor-relabel-filter-processed-by",
                modelValue: _ctx.tempParameters.clientAggregatorType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tempParameters.clientAggregatorType = $event)),
                selectedItem: _ctx.tempParameters.clientAggregatorType,
                options: _ctx.clientAggregatorTypeOptions,
                placeholder: _ctx.$t('urgentRelabel.filter.processedByPlaceholder'),
                class: "w-full",
                onSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTempFilter($event, 'clientAggregatorType')))
              }, null, 8, ["modelValue", "selectedItem", "options", "placeholder"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("urgentRelabel.filter.shipmentType")), 1),
              _createVNode(_component_CustomDropdown, {
                "data-testid": "urgent-delivery-monitor-relabel-filter-product-type",
                placeholder: 
              _ctx.productTypeSelectedCount ||
                _ctx.$t('urgentRelabel.filter.shipmentTypePlaceholder')
            ,
                modelValue: _ctx.productTypeModel,
                class: "w-full mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_12, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productListData, (product, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "flex items-center p-field-checkbox mt-2",
                        key: 'product-' + index
                      }, [
                        _createVNode(_component_Checkbox, {
                          "data-testid": 
                    'urgent-delivery-monitor-relabel-filter-product-checkbox-' +
                      index
                  ,
                          value: product,
                          inputId: 'relabel-product-' + index,
                          name: 'relabel-product-' + index,
                          modelValue: _ctx.selectedProductTypes,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedProductTypes = $event)),
                          onChange: _ctx.onProductTypeChange
                        }, null, 8, ["data-testid", "value", "inputId", "name", "modelValue", "onChange"]),
                        _createVNode("label", {
                          class: "ml-2.5",
                          for: 'relabel-product-' + index
                        }, _toDisplayString(product), 9, ["for"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["placeholder", "modelValue"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("urgentRelabel.filter.originCity")), 1),
              _createVNode(_component_SelectSearch, {
                class: "mt-1.5",
                onFocus: _cache[5] || (_cache[5] = (e) => _ctx.fetchDestinationCity(e)),
                onFilter: _cache[6] || (_cache[6] = (e) => _ctx.fetchDestinationCity(e)),
                isLoading: _ctx.isLoadingCity,
                options: _ctx.optionDestinationCity,
                keyName: "label",
                keyValue: "code",
                placeholder: _ctx.$t('urgentRelabel.filter.originCityPlaceholder'),
                modelValue: _ctx.tempOriginCity,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.tempOriginCity = $event))
              }, null, 8, ["isLoading", "options", "placeholder", "modelValue"])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("urgentRelabel.filter.destinationCity")), 1),
              _createVNode(_component_SelectSearch, {
                class: "mt-1.5",
                onFocus: _cache[8] || (_cache[8] = (e) => _ctx.fetchDestinationCity(e)),
                onFilter: _cache[9] || (_cache[9] = (e) => _ctx.fetchDestinationCity(e)),
                isLoading: _ctx.isLoadingCity,
                options: _ctx.optionDestinationCity,
                keyName: "label",
                keyValue: "code",
                placeholder: _ctx.$t('urgentRelabel.filter.destinationCityPlaceholder'),
                modelValue: _ctx.tempDestinationCity,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.tempDestinationCity = $event))
              }, null, 8, ["isLoading", "options", "placeholder", "modelValue"])
            ]),
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("urgentRelabel.filter.bkdUpdateDate")), 1),
            _createVNode(_component_DateRangePicker, {
              "data-testid": "urgent-delivery-monitor-relabel-date-range",
              modelValue: _ctx.dateRangeModel,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dateRangeModel = $event)),
              class: "w-full",
              "max-range": 365,
              "max-date": new Date()
            }, null, 8, ["modelValue", "max-date"])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("button", {
              "data-testid": "urgent-delivery-monitor-relabel-filter-reset",
              class: "text-red-lp-100 font-semibold text-sm px-6 hover:underline",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
            }, _toDisplayString(_ctx.$t("urgentRelabel.filter.reset")), 1),
            _createVNode(_component_lp_button, {
              "data-testid": "urgent-delivery-monitor-relabel-filter-apply",
              title: _ctx.$t('urgentRelabel.filter.apply'),
              customClass: "w-auto px-6",
              textColor: "white",
              small: "",
              onClick: _ctx.applyFilter
            }, null, 8, ["title", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, _ctx.closeFilter]
  ])
}